<ion-content *ngIf="geladen" #content class="section-content auftragstyp-beladung" [class.schreibgeschuetzt]="auftragdetails?.isReadOnly">

  <div *ngIf="auftragdetails?.isSchreibgeschuetztAnzeigen" class="archiv-message">Schreibgeschützt<span *ngIf="auftragdetails?.schreibschutzGrund"> – {{ auftragdetails.schreibschutzGrund }}</span></div>

  <div class="section">
    <h1 class="kommissionieren-palette-titel"><span *ngIf="oberauftrag">{{ oberauftrag.DetailInfo1 }} - </span>{{ auftrag.Info1 }}</h1>

    <!-- <div class="adresse">
      <div class="info-texte">
        <div *ngIf="oberauftrag">
          <div *ngIf="oberauftrag.DetailInfo2" class="info2 kommissionieren-oberauftrag-detail2"><span>{{ oberauftrag.DetailInfo2 }}</span></div>
        </div>

        <div *ngIf="auftrag.DetailInfo2" class="info2"><span>{{ auftrag.DetailInfo2 }}</span></div>
      </div>
    </div> -->

    <!-- <div class="section buttons-section buttons-section-top">
      <ng-template ngFor let-b [ngForOf]="buttons">
        <ion-button *ngIf="istStatusuebergangErlaubt(b.workflowStatus)" appClick (clicked)="onButtonClicked(b)" expand="full" [color]="b.color" class="status-button">
          <ion-icon *ngIf="b.icon" slot="start" [name]="b.icon"></ion-icon>
          {{ b.text }}
        </ion-button>
      </ng-template>
    </div> -->
  </div>

  <div *ngFor="let c of formularKonfiguration.komponenten">
    <div [ngSwitch]="c.name">
      <!-- Fahrzeug-Kennzeichen -->
      <fahrzeug-kennzeichen-komponente *ngSwitchCase="'Fahrzeug-Kennzeichen'" [auftragdetails]="auftragdetails" [komponente]="c"></fahrzeug-kennzeichen-komponente>

      <!-- Barcode -->
      <auftrag-barcode-komponente *ngSwitchCase="'Barcode'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-barcode-komponente>

      <!-- Lieferung -->
      <auftrag-lieferung-komponente *ngSwitchCase="'Lieferung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-komponente>

      <!-- Unterauftraege -->
      <div *ngSwitchCase="'Unterauftraege'">
        <div *ngIf="unterauftraege.length">
          <div class="section ion-activatable section-unterauftraege">
            <h1>{{ getEinstellung(c, 'Titel', 'Positionen') }}</h1>
            <div class="unterauftraege">
              <app-auftrag-unterauftraege-beladung [auftrag]="auftrag" [unterauftraege]="unterauftraege"></app-auftrag-unterauftraege-beladung>
            </div>
          </div>
        </div>
      </div>

      <!-- LKW-Ladeplan -->
      <div *ngSwitchCase="'LKW-Ladeplan'">
        <div *ngIf="unterauftraege.length">
          <div class="section ion-activatable section-unterauftraege">
            <auftrag-lkw-ladeplan [auftragdetails]="auftragdetails" [auftrag]="auftrag" [unterauftraege]="unterauftraege" [komponente]="c"></auftrag-lkw-ladeplan>
          </div>
        </div>
      </div>

      <!-- Hinweistexte -->
      <auftrag-hinweistexte-komponente *ngSwitchCase="'Hinweistexte'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-hinweistexte-komponente>

      <!-- Auftragsbilder -->
      <auftrag-bilder-komponente *ngSwitchCase="'Bilder'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder-komponente>

      <!-- Bilder (Beladung) -->
      <auftrag-bilder2-komponente *ngSwitchCase="'Bilder2'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder2-komponente>

      <!-- Anmerkungen-->
      <auftrag-anmerkungen-komponente *ngSwitchCase="'Anmerkungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-anmerkungen-komponente>

      <!-- Ext. Auftragsnummer-->
      <auftrag-ext-nummer-komponente *ngSwitchCase="'Ext-Nummer'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-ext-nummer-komponente>

      <!-- Unterschrift -->
      <auftrag-unterschrift-komponente *ngSwitchCase="'Unterschrift'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-unterschrift-komponente>

      <!-- Statusmeldung -->
      <auftrag-statusmeldungen-komponente *ngSwitchCase="'Statusmeldungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-statusmeldungen-komponente>

      <!-- Checkliste -->
      <auftrag-checkliste-komponente *ngSwitchCase="'Checkliste'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-checkliste-komponente>

      <!-- Dateien -->
      <auftrag-dateien-komponente *ngSwitchCase="'Dateien'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-dateien-komponente>

      <!-- Buttons -->
      <auftrag-buttons-komponente *ngSwitchCase="'Buttons'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-buttons-komponente>

    </div>
  </div>
</ion-content>

<div *ngIf="anzeigeBild" class="anzeigebild">
  <pinch-zoom>
    <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(anzeigeBild.src)" />
  </pinch-zoom>

  <ion-button expand="full" fill="clear" appClick (clicked)="onBildClicked(null)">
    <ion-ripple-effect></ion-ripple-effect>
    <ion-icon name="close"></ion-icon> Schließen
  </ion-button>
</div>